import {
  KnownDeliveryState,
  KnownNotificationDtoChannel,
  KnownNotificationDtoLatestStatus,
  KnownTimelineEventDtoNotificationChannel,
  KnownTimelineEventDtoNotificationStatus
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { Colors } from '../../ui/theme/colors';
import { EventNotificationSMS } from '../../ui/components/pure/icons/EventNotificationSMS.icon';
import { EventNotificationEmail } from '../../ui/components/pure/icons/EventNotificationEmail.icon';
import { EventNotificationWebhook } from '../../ui/components/pure/icons/EventNotificationWebhook.icon';
import { SVGIconComponent } from '../../ui/components/pure/icons/types';

export const deliveryStatusToLabelWithCategory: Record<CustomDeliveryStateOptions, string> = {
  delivered: '- Delivered',
  overdue: '- Overdue',
  collected: '- Collected',
  cancelled: '- Cancelled',
  retrieved: '- Retrieved',
  'retrieval-required': '- Retrieval Required',
  abandoned: '- Abandoned',
  completed: 'Completed',
  'not-delivered': 'Not Delivered',
  'current-deliveries-category': 'Current',
  'in-progress': '- In Progress'
};

export enum CustomDeliveryStateOptions {
  Abandoned = 'abandoned',
  Delivered = 'delivered',
  Overdue = 'overdue',
  Collected = 'collected',
  Retrieved = 'retrieved',
  Cancelled = 'cancelled',
  Completed = 'completed',
  NotDelivered = 'not-delivered',
  RetrievalRequired = 'retrieval-required',
  CurrentDeliveriesCategory = 'current-deliveries-category',
  InProgress = 'in-progress'
}

export const OptionsToValuesMap: Record<CustomDeliveryStateOptions, KnownDeliveryState[]> = {
  'current-deliveries-category': [
    KnownDeliveryState.InProgress,
    KnownDeliveryState.Delivered,
    KnownDeliveryState.Overdue,
    KnownDeliveryState.RetrievalRequired
  ],
  'in-progress': [KnownDeliveryState.InProgress],
  delivered: [KnownDeliveryState.Delivered],
  overdue: [KnownDeliveryState.Overdue],
  collected: [KnownDeliveryState.Collected],
  retrieved: [KnownDeliveryState.Retrieved],
  cancelled: [KnownDeliveryState.Cancelled],
  'retrieval-required': [KnownDeliveryState.RetrievalRequired],
  completed: [KnownDeliveryState.Collected, KnownDeliveryState.Retrieved],
  'not-delivered': [KnownDeliveryState.Abandoned, KnownDeliveryState.Cancelled, KnownDeliveryState.DeliveredOffline],
  abandoned: [KnownDeliveryState.Abandoned]
};

export const mapDeliveryNotificationToIcon: Record<
  KnownTimelineEventDtoNotificationChannel | KnownNotificationDtoChannel,
  SVGIconComponent
> = {
  sms: EventNotificationSMS,
  email: EventNotificationEmail,
  webhook: EventNotificationWebhook
};

export const mapDeliveryNotificationToColor: Record<
  KnownNotificationDtoLatestStatus | KnownTimelineEventDtoNotificationStatus,
  string
> = {
  enroute: Colors.bookedScannedInProgressGray,
  scheduled: Colors.bookedScannedInProgressGray,
  delayed: Colors.overdueOrange,
  successful: Colors.collectedGreen,
  failed: Colors.cancelledDeletedRed
};
